// extracted by mini-css-extract-plugin
export default {"customer-organization-form__company-device-policy-inputs-container":"CompanyDevicePolicy_customer-organization-form__company-device-policy-inputs-container__mApef"};